import { applyMiddleware, CombinedState, combineReducers, compose, createStore as _createStore } from 'redux';
import thunk, { ThunkDispatch } from 'redux-thunk';

import {
  fieldsStateReducer,
  calculateReducer,
  calculateResultModalReducer,
  userReducer,
  flatStatsReducer,
  regionIdReducer,
} from '../../reducers';
import { IApplicationContext } from '../../types/applicationContext';
import { IApplicationState, IApplicationStateInitial, TReduxActions } from '../../types/redux';

interface IThunkExt {
  dispatch: ThunkDispatch<IApplicationState, IApplicationContext, TReduxActions>;
}

/* istanbul ignore next */
const composeEnhancers = (() => {
  if (process.env.NODE_ENV === 'development' && process.env.IS_BROWSER_BUILD) {
    const { __REDUX_DEVTOOLS_EXTENSION_COMPOSE__ } = window;

    if (__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) {
      return __REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
        name: `investment-calculator-frontend: ${document.title}`,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      } as any);
    }
  }

  return compose;
})();

/**
 * Хелпер для создания Redux стора
 * @param initialState IApplicationState - предзагруженное состояние
 * @param context
 */
export function createReduxStore(initialState: IApplicationStateInitial, context: IApplicationContext) {
  const reducers = combineReducers<IApplicationState, TReduxActions>({
    user: userReducer,
    fieldsState: fieldsStateReducer,
    calculate: calculateReducer,
    calculateResultModal: calculateResultModalReducer,
    flatStats: flatStatsReducer,
    regionId: regionIdReducer,
  });
  const middlewares = [thunk.withExtraArgument(context)];

  const storeEnhancers = composeEnhancers(applyMiddleware(...middlewares));

  return _createStore<CombinedState<IApplicationState>, TReduxActions, IThunkExt, {}>(
    reducers,
    initialState,
    storeEnhancers,
  );
}
